"use client"

import "./css/nosotros.css"
import { Phone, Users, Tractor } from "lucide-react"
import useCountUp from "../hooks/useCountUp"
import CascadingText from "./CascadingText"

// Importa la imagen desde la ruta correcta
import edificioImagen from "../img/aboutus.png" // Ruta actualizada

const Nosotros = () => {
  const clientesCount = useCountUp(10000, 2000)
  const aniosCount = useCountUp(5, 1500)

  const descripcion1 =
    "Agrocorral es una empresa con más de 5 años de experiencia dedicada a la comercialización de insumos pecuarios especializados para aves, ganado y cerdos. Nacimos con el compromiso de apoyar al productor con soluciones prácticas, accesibles y duraderas para el manejo eficiente de sus animales."
  const descripcion2 =
    "A lo largo de este tiempo, nos hemos consolidado como un aliado confiable en el sector pecuario, gracias a nuestra atención personalizada, entrega oportuna y un catálogo en constante crecimiento que incluye bebederos, comederos, suplementos y equipo básico para granjas."
  const descripcion3 =
    "En Agrocorral, entendemos el esfuerzo detrás de cada crianza. Por eso, trabajamos todos los días para ofrecer productos de calidad que realmente faciliten el trabajo en el campo y contribuyan al bienestar animal."

  const handleWhatsAppClick = () => {
    window.open(
      "https://wa.me/50230544755?text=Hola%20escribo%20de%20la%20p%C3%A1gina%20web%20quiero%20m%C3%A1s%20informaci%C3%B3n",
      "_blank",
    )
  }

  return (
    <section className="nosotros-section" id="Nosotros">
      <div className="nosotros-container">
        <div className="nosotros-grid">
          {/* Columna Izquierda */}
          <div className="nosotros-column-left">
            <div className="decorative-dots"></div>
            <div className="nosotros-image-wrapper">
              <img
                src={edificioImagen || "/placeholder.svg"} // Usando la imagen importada
                alt="Edificio de Agrocorral"
                className="nosotros-image"
              />
              <div
                className="nosotros-contact-box clickable-contact"
                onClick={handleWhatsAppClick}
                style={{ cursor: "pointer" }}
              >
                <div className="contact-icon-wrapper">
                  <Phone size={28} className="contact-icon" />
                </div>
                <div className="contact-details">
                  <p className="contact-phone">3054-4755</p>
                  <p className="contact-info">Ventas</p>
                </div>
              </div>
            </div>
          </div>

          {/* Columna Derecha */}
          <div className="nosotros-column-right">
            <p className="company-subtitle">Agrocorral</p>
            <h2 className="nosotros-title">Confianza y calidad para tu producción pecuaria</h2>
            <div className="title-decorator"></div>
            <p className="nosotros-description">
              <CascadingText text={descripcion1} delayIncrement={10} />
            </p>
            <p className="nosotros-description">
              <CascadingText text={descripcion2} delayIncrement={10} />
            </p>
            <p className="nosotros-description">
              <CascadingText text={descripcion3} delayIncrement={10} />
            </p>

            <div className="nosotros-stats-container">
              <div className="stat-item">
                <Users size={40} className="stat-icon" />
                <div className="stat-text">
                  <p className="stat-main">Más de {clientesCount}</p>
                  <p className="stat-sub">Pedidos entregados</p>
                </div>
              </div>
              <div className="stat-item">
                <Tractor size={40} className="stat-icon" />
                <div className="stat-text">
                  <p className="stat-main">{aniosCount} Años</p>
                  <p className="stat-sub">Junto al productor</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Nosotros
